var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ui-list',{attrs:{"headings":[
      _vm.$tc('models.company'),
      _vm.$tc('models.role'),
      // ''
    ],"sort":[
      { prop: 'companyName', type: false },
    ],"items":_vm.companyUsers},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('ui-list-data',{attrs:{"text":props.item.companyName}}),_c('ui-list-data',{attrs:{"type":"tag","text":_vm.$t('roles.CompanyAdmin')}})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }